export default "__VITE_ASSET__DYzUqeut__"